import { concat } from '../../helpers/common'

const MODULE_NAME = 'SOCIAL_ACCOUNTS/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION
export const GET_FACEBOOK_PAGES_LEAD_GEN_FORMS = concat(MODULE_NAME, 'GET_FACEBOOK_PAGES_LEAD_GEN_FORMS')
export const GET_FACEBOOK_PAGES_LEAD_GEN_FORMS_SUCCESS = concat(
  MODULE_NAME,
  'GET_FACEBOOK_PAGES_LEAD_GEN_FORMS_SUCCESS'
)
export const GET_FACEBOOK_PAGES_LEAD_GEN_FORMS_FAILURE = concat(
  MODULE_NAME,
  'GET_FACEBOOK_PAGES_LEAD_GEN_FORMS_FAILURE'
)
export const CLEAR_GET_FACEBOOK_PAGES_LEAD_GEN_FORMS = concat(MODULE_NAME, 'CLEAR_GET_FACEBOOK_PAGES_LEAD_GEN_FORMS')

export const GET_FACEBOOK_PAGES = concat(MODULE_NAME, 'GET_FACEBOOK_PAGES')
export const GET_FACEBOOK_PAGES_SUCCESS = concat(MODULE_NAME, 'GET_FACEBOOK_PAGES_SUCCESS')
export const GET_FACEBOOK_PAGES_FAILURE = concat(MODULE_NAME, 'GET_FACEBOOK_PAGES_FAILURE')
export const CLEAR_FACEBOOK_PAGES = concat(MODULE_NAME, 'CLEAR_FACEBOOK_PAGES')

export const GET_ACCESSIBLE_SOCIAL_PAGES = concat(MODULE_NAME, 'GET_ACCESSIBLE_SOCIAL_PAGES')
export const GET_ACCESSIBLE_SOCIAL_PAGES_SUCCESS = concat(MODULE_NAME, 'GET_ACCESSIBLE_SOCIAL_PAGES_SUCCESS')
export const GET_ACCESSIBLE_SOCIAL_PAGES_FAILURE = concat(MODULE_NAME, 'GET_ACCESSIBLE_SOCIAL_PAGES_FAILURE')
export const CLEAR_ACCESSIBLE_SOCIAL_PAGES = concat(MODULE_NAME, 'CLEAR_ACCESSIBLE_FACEBOOK_PAGES')

export const DELETE_ACCESSIBLE_SOCIAL_PAGES = concat(MODULE_NAME, 'DELETE_ACCESSIBLE_SOCIAL_PAGES')
export const DELETE_ACCESSIBLE_SOCIAL_PAGES_SUCCESS = concat(MODULE_NAME, 'DELETE_ACCESSIBLE_SOCIAL_PAGES_SUCCESS')
export const DELETE_ACCESSIBLE_SOCIAL_PAGES_FAILURE = concat(MODULE_NAME, 'DELETE_ACCESSIBLE_SOCIAL_PAGES_FAILURE')
export const CLEAR_DELETE_ACCESSIBLE_SOCIAL_PAGES = concat(MODULE_NAME, 'CLEAR_DELETE_ACCESSIBLE_SOCIAL_PAGES')

export const ADD_ACCESSIBLE_SOCIAL_PAGES = concat(MODULE_NAME, 'ADD_ACCESSIBLE_SOCIAL_PAGES')
export const ADD_ACCESSIBLE_SOCIAL_PAGES_SUCCESS = concat(MODULE_NAME, 'ADD_ACCESSIBLE_SOCIAL_PAGES_SUCCESS')
export const ADD_ACCESSIBLE_SOCIAL_PAGES_FAILURE = concat(MODULE_NAME, 'ADD_ACCESSIBLE_SOCIAL_PAGES_FAILURE')
export const CLEAR_ADD_ACCESSIBLE_SOCIAL_PAGES = concat(MODULE_NAME, 'CLEAR_ADD_ACCESSIBLE_SOCIAL_PAGES')

export const GET_FACEBOOK_PAGE_ACCESS_TOKEN = concat(MODULE_NAME, 'GET_FACEBOOK_PAGE_ACCESS_TOKEN')
export const GET_FACEBOOK_PAGE_ACCESS_TOKEN_SUCCESS = concat(MODULE_NAME, 'GET_FACEBOOK_PAGE_ACCESS_TOKEN_SUCCESS')
export const GET_FACEBOOK_PAGE_ACCESS_TOKEN_FAILURE = concat(MODULE_NAME, 'GET_FACEBOOK_PAGE_ACCESS_TOKEN_FAILURE')
export const CLEAR_FACEBOOK_PAGE_ACCESS_TOKEN = concat(MODULE_NAME, 'CLEAR_FACEBOOK_PAGE_ACCESS_TOKEN')

export const CREATE_FACEBOOK_PAGE_ACCESS_REQUEST = concat(MODULE_NAME, 'CREATE_FACEBOOK_PAGE_ACCESS_REQUEST')
export const CREATE_FACEBOOK_PAGE_ACCESS_REQUEST_SUCCESS = concat(
  MODULE_NAME,
  'CREATE_FACEBOOK_PAGE_ACCESS_REQUEST_SUCCESS'
)
export const CREATE_FACEBOOK_PAGE_ACCESS_REQUEST_FAILURE = concat(
  MODULE_NAME,
  'CREATE_FACEBOOK_PAGE_ACCESS_REQUEST_FAILURE'
)
export const CLEAR_CREATE_FACEBOOK_PAGE_ACCESS_REQUEST = concat(
  MODULE_NAME,
  'CLEAR_CREATE_FACEBOOK_PAGE_ACCESS_REQUEST'
)

export const GET_INSTAGRAM_ACCOUNTS = concat(MODULE_NAME, 'GET_INSTAGRAM_ACCOUNTS')
export const GET_INSTAGRAM_ACCOUNTS_SUCCESS = concat(MODULE_NAME, 'GET_INSTAGRAM_ACCOUNTS_SUCCESS')
export const GET_INSTAGRAM_ACCOUNTS_FAILURE = concat(MODULE_NAME, 'GET_INSTAGRAM_ACCOUNTS_FAILURE')
export const CLEAR_INSTAGRAM_ACCOUNTS = concat(MODULE_NAME, 'CLEAR_INSTAGRAM_ACCOUNTS')

export const GET_BACKED_INSTAGRAM_ACCOUNTS = concat(MODULE_NAME, 'GET_BACKED_INSTAGRAM_ACCOUNTS')
export const GET_BACKED_INSTAGRAM_ACCOUNTS_SUCCESS = concat(MODULE_NAME, 'GET_BACKED_INSTAGRAM_ACCOUNTS_SUCCESS')
export const GET_BACKED_INSTAGRAM_ACCOUNTS_FAILURE = concat(MODULE_NAME, 'GET_BACKED_INSTAGRAM_ACCOUNTS_FAILURE')
export const CLEAR_BACKED_INSTAGRAM_ACCOUNTS = concat(MODULE_NAME, 'CLEAR_BACKED_INSTAGRAM_ACCOUNTS')

export const GET_FACEBOOK_DEBUG_TOKENS = concat(MODULE_NAME, 'GET_FACEBOOK_DEBUG_TOKENS')
export const GET_FACEBOOK_DEBUG_TOKENS_SUCCESS = concat(MODULE_NAME, 'GET_FACEBOOK_DEBUG_TOKENS_SUCCESS')
export const GET_FACEBOOK_DEBUG_TOKENS_FAILURE = concat(MODULE_NAME, 'GET_FACEBOOK_DEBUG_TOKENS_FAILURE')
export const CLEAR_GET_FACEBOOK_DEBUG_TOKENS = concat(MODULE_NAME, 'CLEAR_GET_FACEBOOK_DEBUG_TOKENS')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

// facebook pages
export function getFacebookPages(params, skipContextPartnershipId) {
  return { type: GET_FACEBOOK_PAGES, params, skipContextPartnershipId }
}

export function getFacebookPagesSuccess(pagesData) {
  return { type: GET_FACEBOOK_PAGES_SUCCESS, pagesData }
}

export function getFacebookPagesFailure(error) {
  return { type: GET_FACEBOOK_PAGES_FAILURE, error }
}

export function clearFacebookPages() {
  return { type: CLEAR_FACEBOOK_PAGES }
}

// add accessible social pages(facebook or TikTok)
export function addAccessibleSocialPages(pageData) {
  return { type: ADD_ACCESSIBLE_SOCIAL_PAGES, pageData }
}

export function addAccessibleSocialPagesSuccess(pageData) {
  return { type: ADD_ACCESSIBLE_SOCIAL_PAGES_SUCCESS, pageData }
}

export function addAccessibleSocialPagesFailure(error) {
  return { type: ADD_ACCESSIBLE_SOCIAL_PAGES_FAILURE, error }
}

export function clearAddAccessibleSocialPages() {
  return { type: CLEAR_ADD_ACCESSIBLE_SOCIAL_PAGES }
}

// accessible social(facebook, tiktok) pages(shared to the current user/partnership or user/rights_holder)
export function getAccessibleSocialPages(params = {}) {
  return { type: GET_ACCESSIBLE_SOCIAL_PAGES, params }
}

export function getAccessibleSocialPagesSuccess(pagesData) {
  return { type: GET_ACCESSIBLE_SOCIAL_PAGES_SUCCESS, pagesData }
}

export function getAccessibleSocialPagesFailure(error) {
  return { type: GET_ACCESSIBLE_SOCIAL_PAGES_FAILURE, error }
}

export function clearAccessibleSocialPages() {
  return { type: CLEAR_ACCESSIBLE_SOCIAL_PAGES }
}

// delete accessible social pages(shared to the current user/partnership)
export function deleteAccessibleSocialPages(id) {
  return { type: DELETE_ACCESSIBLE_SOCIAL_PAGES, id }
}

export function deleteAccessibleSocialPagesSuccess(id) {
  return { type: DELETE_ACCESSIBLE_SOCIAL_PAGES_SUCCESS, id }
}

export function deleteAccessibleSocialPagesFailure(error) {
  return { type: DELETE_ACCESSIBLE_SOCIAL_PAGES_FAILURE, error }
}

export function clearDeleteAccessibleSocialPages() {
  return { type: CLEAR_DELETE_ACCESSIBLE_SOCIAL_PAGES }
}

// facebook page access token
export function getFacebookPageAccessToken(facebookPageId) {
  return { type: GET_FACEBOOK_PAGE_ACCESS_TOKEN, facebookPageId }
}

export function getFacebookPageAccessTokenSuccess(accessToken, facebookPageId) {
  return { type: GET_FACEBOOK_PAGE_ACCESS_TOKEN_SUCCESS, accessToken, facebookPageId }
}

export function getFacebookPageAccessTokenFailure(error, facebookPageId) {
  return { type: GET_FACEBOOK_PAGE_ACCESS_TOKEN_FAILURE, error, facebookPageId }
}

export function clearFacebookPageAccessToken() {
  return { type: CLEAR_FACEBOOK_PAGE_ACCESS_TOKEN }
}

// Create facebook page access request
export function createFacebookPageAccessRequest(data) {
  return { type: CREATE_FACEBOOK_PAGE_ACCESS_REQUEST, data }
}

export function createFacebookPageAccessRequestSuccess(data) {
  return { type: CREATE_FACEBOOK_PAGE_ACCESS_REQUEST_SUCCESS, data }
}

export function createFacebookPageAccessRequestFailure(error) {
  return { type: CREATE_FACEBOOK_PAGE_ACCESS_REQUEST_FAILURE, error }
}

export function clearCreateFacebookPageAccessRequest() {
  return { type: CLEAR_CREATE_FACEBOOK_PAGE_ACCESS_REQUEST }
}

// instagram accounts
export function getInstagramAccounts(facebookPageId, accessToken) {
  return { type: GET_INSTAGRAM_ACCOUNTS, facebookPageId, accessToken }
}

export function getInstagramAccountsSuccess(accountsData, facebookPageId) {
  return { type: GET_INSTAGRAM_ACCOUNTS_SUCCESS, accountsData, facebookPageId }
}

export function getInstagramAccountsFailure(error, facebookPageId) {
  return { type: GET_INSTAGRAM_ACCOUNTS_FAILURE, error, facebookPageId }
}

export function clearInstagramAccounts() {
  return { type: CLEAR_INSTAGRAM_ACCOUNTS }
}

// baked instagram accounts
export function getBackedInstagramAccounts(facebookPageId, accessToken) {
  return { type: GET_BACKED_INSTAGRAM_ACCOUNTS, facebookPageId, accessToken }
}

export function getBackedInstagramAccountsSuccess(accountsData, facebookPageId) {
  return { type: GET_BACKED_INSTAGRAM_ACCOUNTS_SUCCESS, accountsData, facebookPageId }
}

export function getBackedInstagramAccountsFailure(error) {
  return { type: GET_BACKED_INSTAGRAM_ACCOUNTS_FAILURE, error }
}

export function clearBackedInstagramAccounts() {
  return { type: CLEAR_BACKED_INSTAGRAM_ACCOUNTS }
}

// Get facebook pages lead gen forms
export function getFacebookPagesLeadGenForms(params) {
  return { type: GET_FACEBOOK_PAGES_LEAD_GEN_FORMS, params }
}

export function getFacebookPagesLeadGenFormsSuccess(data) {
  return { type: GET_FACEBOOK_PAGES_LEAD_GEN_FORMS_SUCCESS, data }
}

export function getFacebookPagesLeadGenFormsFailure(error) {
  return { type: GET_FACEBOOK_PAGES_LEAD_GEN_FORMS_FAILURE, error }
}

export function clearGetFacebookPagesLeadGenForms() {
  return { type: CLEAR_GET_FACEBOOK_PAGES_LEAD_GEN_FORMS }
}

// Get facebook debug tokens
export function getFacebookDebugTokens(params) {
  return { type: GET_FACEBOOK_DEBUG_TOKENS, params }
}

export function getFacebookDebugTokensSuccess(data) {
  return { type: GET_FACEBOOK_DEBUG_TOKENS_SUCCESS, data }
}

export function getFacebookDebugTokensFailure(error) {
  return { type: GET_FACEBOOK_DEBUG_TOKENS_FAILURE, error }
}

export function clearGetFacebookDebugTokens() {
  return { type: CLEAR_GET_FACEBOOK_DEBUG_TOKENS }
}
